import { useEffect, useState } from "react";
import * as api from "./api.js";

let cached: boolean | null = null;
let inFlight: Promise<boolean> | null = null;

/**
 * Whether self-service sign-up is open (server switch REGISTRATION_OPEN). Treated as
 * closed until the server says otherwise, so the locked state never flickers open.
 */
export function useRegistrationOpen(): boolean {
  const [open, setOpen] = useState<boolean>(cached ?? false);
  useEffect(() => {
    if (cached !== null) return;
    inFlight ??= api
      .getSiteConfig()
      .then((c) => (cached = c.registration_open))
      .catch(() => false);
    let live = true;
    void inFlight.then((v) => live && setOpen(v));
    return () => {
      live = false;
    };
  }, []);
  return open;
}
